<template>
	<div :class="classes">
		<div class="team-list-placeholder__icons">
			<FontAwesomeIcon
				class="team-list-placeholder__icon"
				:icon="[ `fas`, `users` ]"
			/>
		</div>
		<h1 class="team-list-placeholder__heading">
			{{ $t( "common.TeamListPlaceholder_noTeamsMessage" ) }}
		</h1>
		<div class="team-list-placeholder__buttons">
			<TeamingButton
				@click="$emit( `create` )"
			>
				{{ $t( "common.TeamListPlaceholder_createButton" ) }}
			</TeamingButton>
		</div>
	</div>
</template>

<script>
import TeamingButton from "../buttons/TeamingButton.vue";

export default {
	name: "TeamListPlaceholder",
	components: {
		TeamingButton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"team-list-placeholder": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$team-list-placeholder-icon-color: $color1-400;
$team-list-placeholder-icon-background-color: $color1-400;
$team-list-placeholder-heading-color: $color1-500;
$team-list-placeholder-subheading-color: $color1-500;

.team-list-placeholder {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.team-list-placeholder__icons {
	margin: 1.6rem 0;
}

.team-list-placeholder__icon {
	color: $team-list-placeholder-icon-color;
	@include font-and-line-for(7);
	border-radius: 0.5rem;
}

.team-list-placeholder__heading {
	@include font-and-line-for(1);
	color: $team-list-placeholder-heading-color;
	font-weight: 600;
}

.team-list-placeholder__subheading {
	margin: 1rem 0;
	@include font-and-line-for(0);
	color: $team-list-placeholder-subheading-color;
}

.team-list-placeholder__buttons {
	margin-top: 3.5rem;
}
</style>
